import { render, staticRenderFns } from "./btnClose.vue?vue&type=template&id=31ecd682&scoped=true&"
import script from "./btnClose.vue?vue&type=script&lang=js&"
export * from "./btnClose.vue?vue&type=script&lang=js&"
import style0 from "./btnClose.vue?vue&type=style&index=0&id=31ecd682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ecd682",
  null
  
)

export default component.exports